export default __webpack_public_path__ + "static/media/no-results.4e5e3233.png";